const filterNames = [
  "effect",

  "sharpen",
  "blur",
  "pixelation",
  "oldMovie",
  "diffusion",
  "edges",
  "shape",
  "flip",
  "opacity",
];

export const filterNamesFilter = [
  "art",
  "sharpen",
  "mirror",
  "vignette",
  "blur",
  "ripple",
  "noise",
  "shape",
  "diffusion",
  "pixelation",
  "edges",
];
export const filterNamesFilterColor = [
  "red",
  "blue",
  "green",
  "saturation",
  "brightness",
  "posterize",
  "nocolor",
  "graysepia",
];

export default filterNames;
